import { TFunction } from 'i18next';
import * as yup from 'yup';

import { BPNS_REGEX } from '../constants/sites.constant';
import { ISite } from '../interfaces/ISite';

export type SiteFormData = {
  name: string;
  bpns: string;
};

export const createSiteSchema = (
  existingSites: ISite[],
  t: TFunction,
): yup.ObjectSchema<SiteFormData> => {
  return yup.object({
    name: yup.string().required(t('manageSitesDialog.validationErrors.siteNameRequired')).trim(),
    bpns: yup
      .string()
      .required(t('manageSitesDialog.validationErrors.bpnsRequired'))
      .trim()
      .matches(BPNS_REGEX, t('manageSitesDialog.validationErrors.bpnsInvalid'))
      .test('unique-bpns', t('manageSitesDialog.validationErrors.bpnsDuplicate'), (value) => {
        return !existingSites.some((site) => {
          return site.bpns === value;
        });
      }),
  });
};
